<template>
  <div class="indoor">
    <div>
      <van-nav-bar
        @click-left="navTo('/room/1')"
        fixed
        placeholder
        :title="gamename"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <transition name="drawer-transtion">
      <div class="drawer" v-show="show">
        <van-tabs type="card" color="#2694d5">
          <van-tab :title="$t('indoor.size')">
            <SizeTab
              @size="size"
              :target="target"
              :odds="odds"
              :combination="combination"
              :clear="clear"
              ref="size"
            ></SizeTab>
          </van-tab>
          <van-tab id="section" :title="$t('indoor.number')">
            <NumberTab
              @num="num"
              :combination="combination"
              :target="target"
              :odds="odds"
              :clear="clear"
              ref="num"
            ></NumberTab>
          </van-tab>
          <van-tab :title="$t('indoor.special')">
            <SpecialTab
              @special="special"
              :combination="combination"
              :target="target"
              :odds="odds"
              :clear="clear"
              ref="special"
            ></SpecialTab>
          </van-tab>
        </van-tabs>
      </div>
    </transition>

    <div>
      <van-popup
        safe-area-inset-bottom
        style="margin-bottom: 60px; background-color: #abe0ff"
        :overlay="false"
        position="bottom"
        v-model="sheetShow"
        get-container="#footer"
      >
        <div>{{ $t("indoor.text") }}</div>
        <div style="text-align: left">
          <h4 style="margin: 0; padding: 0; color: #fff">Quick order</h4>
        </div>
        <div style="margin: 8px 0 8px 0">
          <van-grid :column-num="6">
            <van-grid-item @click="priceClick(10)" icon="" text="10" />
            <van-grid-item @click="priceClick(50)" icon="" text="50" />
            <van-grid-item @click="priceClick(100)" icon="" text="100" />
            <van-grid-item @click="priceClick(200)" icon="" text="200" />
            <van-grid-item @click="priceClick(500)" icon="" text="500" />
            <van-grid-item @click="priceClick(1000)" icon="" text="1000" />
          </van-grid>
          <!-- <input
            @click="priceClick(10)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="10"
          />
          <input
            @click="priceClick(50)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="50"
          />
          <input
            @click="priceClick(100)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="100"
          />
          <input
            @click="priceClick(200)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="200"
          />
          <input
            @click="priceClick(500)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="500"
          />
          <input
            @click="priceClick(1000)"
            class="input-button-style"
            type="button"
            style="width: 45px;height: 45px;text-align: center"
            value="1000"
          /> -->
        </div>
        <div style="margin: 5px">
          <van-row>
            <van-col style="font-size: 14px; color: #fff" span="8"
              >purchasing price：</van-col
            >
            <van-col span="6">
              <input
                v-model="price"
                style="
                  width: 80px;
                  border-radius: 10px;
                  height: 30px;
                  border: none;
                "
              />
            </van-col>
            <van-col span="5">
              <van-button
                @click="buy"
                style="width: 55px"
                round
                size="small"
                color="#470283"
                type="info"
                >Buy</van-button
              >
            </van-col>
            <van-col span="4">
              <van-button
                @click="reSet"
                style="width: 55px; margin-right: 5px"
                round
                size="small"
                color="#cb0816"
                type="primary"
                >Reset</van-button
              >
            </van-col>
            <van-col span="1"></van-col>
          </van-row>
        </div>
      </van-popup>
    </div>

    <div v-if="!show" class="nav-bottom">
      <div style="padding: 20px">
        <van-row>
          <van-col span="12">
            <div>
              {{ $t("indoor.until") }} {{ gamePeriod.showPeriodId }}
              {{ $t("indoor.period") }}
            </div>
            <div style="margin-top: 5px">-</div>
            <div style="margin-top: 5px">
              {{
                gamePeriod.periodStatus == 0
                  ? gamePeriod.awardTime
                  : "Lottery..."
              }}
            </div>
          </van-col>
          <van-col span="12">
            <div style="color: blue">{{ $t("indoor.balance") }}：</div>
            <div style="margin-top: 5px">{{ money }}</div>
          </van-col>
        </van-row>
      </div>
    </div>

    <div v-if="!show" class="nav-bottom" style="margin-top: 1px">
      <div style="padding: 20px">
        <van-row>
          <van-col span="8">
            <div>{{ $t("indoor.periods") }}</div>
            <div style="font-size: 12px; margin-top: 20px; color: red">
              {{ periodLast.showPeriodId }} {{ $t("indoor.period") }}
            </div>
          </van-col>
          <van-col span="8">
            <div>{{ $t("indoor.total") }}</div>
            <div style="font-size: 12px; margin-top: 20px">
              {{ periodLast.awardNum }}
            </div>
          </van-col>
          <van-col span="8">
            <div>{{ $t("indoor.result") }}</div>
            <div style="font-size: 12px; margin-top: 20px">
              {{ periodLast.awardResult }}
            </div>
          </van-col>
        </van-row>
        <!-- <van-sticky v-if="!show" class="sticky-style">
          <div @click="" class="sticky-item">
            <van-icon size="20px" name="descending" />
          </div>
        </van-sticky> -->
      </div>
    </div>

    <div v-if="!show" class="nav-bottom-bottom" style="font-size: 12px">
      <van-grid style="margin: 0" :border="false" :column-num="5">
        <van-grid-item icon="" :text="$t('indoor.user')" />
        <van-grid-item icon="" :text="$t('indoor.number')" />
        <van-grid-item icon="" :text="$t('indoor.categroy')" />
        <van-grid-item icon="" :text="$t('indoor.transaction')" />
        <van-grid-item icon="" :text="$t('indoor.operation')" />
      </van-grid>
    </div>

    <div v-if="!show" class="list-style" style="margin-top: 20px">
      <div v-for="(item, index) in periodList" :key="index">
        <van-row style="margin-top: 10px">
          <van-col span="12">{{ item.showPeriodId }} period</van-col>
          <van-col span="4">{{ item.awardNum }}</van-col>
          <van-col span="8">{{ item.total }} {{ item.awardResult }}</van-col>
        </van-row>
      </div>
    </div>

    <div class="footer" id="footer">
      <div style="width: 80%; margin: 0 auto; padding: 7px 0 7px 0">
        <van-button
          v-if="!show"
          @click="betting(true)"
          color="#856660"
          round
          block
          type="info"
          native-type="submit"
          >{{ $t("button.betting") }}</van-button
        >
        <van-button
          v-else
          @click="betting(false)"
          color="#856660"
          round
          block
          type="info"
          native-type="submit"
          >{{ $t("button.betting1") }}</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NumberTab from "@/components/NumberTab.vue";
import SizeTab from "@/components/SizeTab.vue";
import SpecialTab from "@/components/SpecialTab.vue";

import {
  gameData,
  order,
  getPeriodStatus,
  getInfo,
  getPeriodIng,
} from "@/common/api/api";

export default {
  name: "indoor",
  data() {
    return {
      gamename: "VIP1",
      show: false,
      sheetShow: false,
      price: "",
      target: [],
      odds: [],
      combination: false,
      clear: false,
      order: {
        uid: "",
        orderInfo: "",
        orderCash: "",
        gameId: "",
        gameName: "",
        gamePeriod: "",
        gameCash: "",
        userId: "",
      },
      gamePeriod: {},
      sizeVal: {
        val: "",
        total: "",
      },
      numVal: {
        val: "",
        total: "",
      },
      specialVal: {
        val: "",
        total: "",
      },
      total: 0,
      totalPrice: 0,
      distVal: "",
      userInfo: {},
      money: "",
      periodList: [],
      periodLast: {},
      periodStatus: "",
      timer: "",
      timer1: "",
      roomId: "",
    };
  },
  components: {
    SizeTab,
    NumberTab,
    SpecialTab,
  },
  watch: {
    periodStatus(newValue, oldValue) {},
  },
  created() {
    this.roomId = this.$route.params && this.$route.params.id;
    this.userInfo = this.$store.getters.userInfo;
    this.gameData(this.roomId, "1", this.userInfo.userId);
    this.getPeriodIng();
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.gamePeriod.periodStatus == 1) {
        this.$toast({
          duration: 2000,
          message: "The draw is coming soon, now closed...",
        });
      }
    }, 1000);
    this.timer1 = setInterval(() => {
      const time1 = Date.parse(new Date());
      const time2 = Date.parse(this.gamePeriod.awardTime);

      if (parseInt(time2 - time1) / 1000 <= 10) {
        this.gamePeriod.periodStatus = 1;
      }
      if (time1 > time2) {
        this.gamePeriod.periodStatus = 1;
        this.getPeriodIng();
        this.gameData(this.roomId, "1", this.userInfo.userId);
      }
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
  },
  methods: {
    getPeriodStatus() {
      getPeriodStatus().then((res) => {
        this.periodStatus = res.data;
        if (this.periodStatus != 0) {
          this.$toast({
            duration: 5000,
            message: "The draw is coming soon, now closed...",
          });
        }
      });
    },
    navTo(path) {
      this.$router.push(path);
    },
    betting(val) {
      this.show = val;
      this.sheetShow = val;
    },
    priceClick(value) {
      this.price = value;
    },
    size(val) {
      // console.log(val);
      this.total += Number(val.total);
      this.distVal += val.val;
    },
    num(val) {
      this.total += Number(val.total);
      this.distVal += val.val;
    },
    special(val) {
      this.total += Number(val.total);
      this.distVal += val.val;
    },
    buy() {
      this.combination = true;
      this.$nextTick(() => {
        // console.log(Number(this.price))
        this.totalPrice = 0;
        this.totalPrice += this.total * Number(this.price);
        this.$dialog
          .confirm({
            message:
              "chosen " +
              this.total +
              " Note play, total amount：" +
              this.totalPrice,
          })
          .then(() => {
            this.order.uid =
              this.userInfo.username + "(" + this.userInfo.userId + ")";
            this.order.orderInfo = this.distVal;
            this.order.orderCash = this.totalPrice;
            this.order.gameId = "1";
            this.order.gameName = this.gamename;
            this.order.gamePeriod = this.gamePeriod.periodId;
            this.order.gameCash = this.price;
            this.order.userId = this.userInfo.userId;
            if (this.gamePeriod.periodStatus == 0 && Number(this.price) != 0) {
              // console.log(this.order);
              // this.reSet();
              // this.combination = false;
              order(this.order).then((res) => {
                this.$toast.success({
                  message: "Betting success",
                });
                this.show = false;
                this.sheetShow = false;
                getInfo().then((res) => {
                  this.userInfo = res.data;
                  this.money = this.userInfo.money;
                });
                this.reSet();
                this.combination = false;
              });
            } else {
              if (Number(this.price) == 0) {
                this.$toast.fail({
                  duration: 5000,
                  message: "Please enter the purchase amount",
                });
              } else {
                this.$toast.fail({
                  duration: 5000,
                  message: "The draw is coming soon, now closed...",
                });
              }
            }
          })
          .catch(() => {
            this.combination = false;
            this.reSet();
          });
      });
    },
    gameData(roomId, gameId, userId) {
      gameData(roomId, gameId, userId).then((res) => {
        this.target = res.data;
        this.odds = res.odds;
        this.money = res.userInfo.money;
        this.periodList = res.list;
        this.periodLast = this.periodList[0];
        // console.log(res)
      });
    },
    getGameInfo(roomId) {},
    getPeriodIng() {
      getPeriodIng().then((res) => {
        this.gamePeriod = res.data;
      });
    },
    reSet() {
      this.price = "";
      this.total = 0;
      this.totalPrice = 0;
      this.distVal = "";
      this.$nextTick(() => {
        if (this.$refs.size) {
          this.$refs.size.initOrigin();
        }
      });
      this.$nextTick(() => {
        if (this.$refs.num) {
          this.$refs.num.initOrigin();
        }
      });
      this.$nextTick(() => {
        if (this.$refs.special) {
          this.$refs.special.initOrigin();
        }
      });
    },
  },
};
</script>

<style>
.nav-bottom {
  background-color: #1e1c38;
  color: #fff;
}

.drawer-enter-active,
.drawer-leave-active {
  transition: transform 0.3s ease;
}

.drawer-enter,
.drawer-leave-to {
  transform: translateY(-100%);
}

.drawer {
  position: absolute;
  width: 100%;
  top: 46px;
  left: 0;
  background-color: white;
}

.drawer-bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: #fff;
}

.sticky-style {
  position: relative;
}

.sticky-item {
  position: absolute;
  right: 0px;
  bottom: 0.5px;
}

.input-button-style {
  border-radius: 100%;
  /* height: 30px; */
  border: none;
  /* margin: 0 6px 0 6px; */
  background: linear-gradient(180deg, #7599f5, #4160e7);
}

.nav-bottom-bottom {
  border: solid 1px #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.footer {
  background-color: #1e1c38;
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  z-index: 1;
}
</style>
